export enum PayoutAddressStatus {
    APPROVED = 'APPROVED',
    AWAITED = 'AWAITED',
    DISCARDED = 'DISCARDED'
}
